import { cn } from "./cn.js";

/**
 * RFQ status badge. Single source of truth — see design.md §2 status colors.
 * Keep these in lockstep with backend RfqStatus values.
 */
export type RfqStatus = "SUBMITTED" | "IN_REVIEW" | "CLOSED" | "CANCELLED";

const labels: Record<RfqStatus, string> = {
  SUBMITTED: "Submitted",
  IN_REVIEW: "In review",
  CLOSED: "Closed",
  CANCELLED: "Cancelled",
};

const styles: Record<RfqStatus, string> = {
  SUBMITTED: "bg-brand-50 text-brand-800 border-brand-200",
  IN_REVIEW: "bg-amber-50 text-amber-800 border-amber-200",
  CLOSED: "bg-slate-100 text-slate-700 border-slate-200",
  CANCELLED: "bg-rose-50 text-rose-700 border-rose-200",
};

export function StatusBadge({ status, className }: { status: RfqStatus; className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        styles[status],
        className,
      )}
    >
      {labels[status]}
    </span>
  );
}

export function statusLabel(status: RfqStatus): string {
  return labels[status];
}
